

















import { apiCommodityCommodityStoreRecommend } from '@/api'
import { asRequiredDeep } from 'vtils'
import { defineClassComponent } from '@/hooks'
import { goodsProvider } from '../provider'
import { nextTick, ref } from '@vue/composition-api'

export default defineClassComponent(
  () =>
    class {
      // 商品数据
      goodsData = goodsProvider.inject()

      showRecommend = ref(false)

      loadData = ({ pageNumber }: any) => {
        return apiCommodityCommodityStoreRecommend({
          storeId: this.goodsData.value.merchantId,
          commodityId: this.goodsData.value.commodityId,
          pageIndex: pageNumber,
          pageSize: 10,
        })
          .then(asRequiredDeep)
          .then(res => {
            if (pageNumber === 1 && res.list.length > 0) {
              nextTick(() => (this.showRecommend.value = true))
            }
            return res
          })
      }
    },
)
